<template>
    <div class="home">
        <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/nFG1bgxaTpw" scrolling="yes" seamless="seamless" style="display:block; width:100%; height:70vh;" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
</template>

<script>

export default {
    name: 'Home',
    components: {
    }
}
</script>
